import React, {Fragment} from 'react';
import {
  BrowserRouter as Router,
  Routes as Switch,
  Route
} from "react-router-dom";
import {MAIN_ROUTES} from './_config/routes';

import Login from './modules/login';
import PrivateLogin from './modules/private-login';
import AppModules from './modules/app_modules';
import AuthWrapper from './modules/hoc/auth_wrapper';

const AuthComponent = AuthWrapper(AppModules);

function App() {
  return (
    <Router>
      <Fragment>
        <Switch>
          <Route exact path={MAIN_ROUTES.login} element={<Login />} />
          <Route exact path={MAIN_ROUTES.private_login} element={<PrivateLogin />} />
          <Route exact path={`${MAIN_ROUTES.app_modules}/:module`} element={<AuthComponent />} />
          <Route exact path={`${MAIN_ROUTES.app_modules}/:module/:uuid`} element={<AuthComponent />} />
          <Route path='*' element={<NotFound />} />
        </Switch>
      </Fragment>
    </Router>
  );
}

function NotFound() {
  return(
    <>Not found</>
  );
}

export default App;
